module.exports = __webpack_public_path__ + "img/g_01.1a02d630.png";